import { Env } from 'dd-client/site/config/utils/env';

const isDev = (): boolean => process.env.NODE_ENV === Env.DEVELOPMENT;
const isProduction = (): boolean => process.env.NODE_ENV === Env.PRODUCTION;

export {
  isDev,
  isProduction,
};
